const personalData = () => import('@/views/personal-center/personalData');
const noticeSwitch = () => import('@/views/personal-center/noticeSwitch');
const myNews = () => import('@/views/personal-center/myNews');
const myBalance = () => import('@/views/personal-center/myBalance');
export default [{
		path: '/personal-data',
		component: personalData,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '个人中心',
				url: './my-balance',
			},
			{
				name: '个人资料',
				url: '',
			},
		],
	},

	{
		path: '/notice-switch',
		component: noticeSwitch,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '个人中心',
				url: './my-balance',
			},
			{
				name: '通知开关',
				url: '',
			},
		],
	},

	{
		path: '/my-news',
		component: myNews,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '个人中心',
				url: './my-balance',
			},
			{
				name: '我的消息',
				url: '',
			},
		],
	},

	{
		path: '/my-balance',
		component: myBalance,
		meta: [{
				name: '首页',
				url: './order-list',
			},
			{
				name: '个人中心',
				url: './my-balance',
			},
			{
				name: '我的余额',
				url: '',
			},
		],
	}
]
